// src/stores/rateLimit.ts
import { defineStore } from "pinia";
import { ref } from "vue";

export const useRateLimitStore = defineStore("rateLimit", () => {
    const isRateLimited = ref(false);
    const resetTimestamp = ref<number>(0);

    /**
     * Triggers the rate limit lock
     * @param retryAfterSeconds - Seconds until the limit resets
     */
    const triggerRateLimit = (retryAfterSeconds: number) => {
        isRateLimited.value = true;
        resetTimestamp.value = Date.now() + retryAfterSeconds * 1000;
    };

    /**
     * Clears the rate limit lock
     */
    const clearRateLimit = () => {
        isRateLimited.value = false;
        resetTimestamp.value = 0;
    };

    /**
     * Helper to check if limit is still active in real-time
     */
    const checkIsStillRateLimited = (): boolean => {
        if (isRateLimited.value && Date.now() >= resetTimestamp.value) {
            clearRateLimit();
            return false;
        }
        return isRateLimited.value;
    };

    return {
        isRateLimited,
        resetTimestamp,
        triggerRateLimit,
        clearRateLimit,
        checkIsStillRateLimited,
    };
});